// src/components/AdminPortal/UserManagement/AdminUsers.js
import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import "../../User.css";
import "../UserManagement.css";
import Axios from "../../../utils/axios";

const AdminUsers = () => {
  const [adminUsers, setAdminUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);

  const fetchAdminUsers = async () => {
    try {
      setLoading(true);

      const response = await Axios.get(`/api/userApplicationRole/getAllAdmins`);

      const data = response?.data || [];
      setAdminUsers(Array.isArray(data) ? data : [data]);
    } catch (error) {
      toast.error("Failed to load admin users");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAdminUsers();
  }, []);

  const filteredAdminUsers = adminUsers.filter(
    (user) =>
      user.username?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.applicationRoleName
        ?.toLowerCase()
        .includes(searchTerm.toLowerCase()) ||
      user.applicationName?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="table-container">
      <h2>Admin Users</h2>
      <div className="search-and-new">
        <input
          type="text"
          placeholder="Search by Username, Role, or Application..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
        <button onClick={() => setSearchTerm("")} className="clear-button">
          Clear
        </button>
      </div>

      {loading ? (
        <p>Loading admin users...</p>
      ) : (
        <table className="data-table">
          <thead>
            <tr>
              <th>Username</th>
              <th>Application Role</th>
              <th>Application Name</th>
            </tr>
          </thead>
          <tbody>
            {filteredAdminUsers.length > 0 ? (
              filteredAdminUsers.map((user) => (
                <tr key={user.id}>
                  <td>{user.username}</td>
                  <td>{user.applicationRoleName}</td>
                  <td>{user.applicationName}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" style={{ textAlign: "center" }}>
                  No admin users found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default AdminUsers;
